export enum AuthProvider {
  Google = "google.com",
  Password = "password",
}
